import { HfsSettingsActionEnum } from 'fleet-data-model';
import { SettingTypeEnum, type Update } from '../../types';

export const mapWarningLightErrorIndicationEnabledTarget = (update: Update) => {
  const updateItem = update.group?.find(
    (item) => item.settingType === SettingTypeEnum.HeadlightsErrorIndication
  );
  return updateItem?.enabled === undefined
    ? undefined
    : {
        hfsActionId: HfsSettingsActionEnum.WARNING_LIGHT_ERROR_INDICATION_ENABLED,
        iprId: update.assetId,
        payload: {
          errorIndicationEnabled: updateItem.enabled,
        },
      };
};

export const mapWarningLightThemeTarget = (update: Update) => {
  const updateItem = update.group?.find(
    (item) => item.settingType === SettingTypeEnum.HeadlightsTheme
  );
  return updateItem?.value === undefined
    ? undefined
    : {
        hfsActionId: HfsSettingsActionEnum.WARNING_LIGHT_THEME,
        iprId: update.assetId,
        payload: {
          theme: updateItem.value,
        },
      };
};

export const mapWarningLightModeTarget = (update: Update) => {
  const updateItem = update.group?.find(
    (item) => item.settingType === SettingTypeEnum.HeadlightsMode
  );
  return updateItem?.value === undefined
    ? undefined
    : {
        hfsActionId: HfsSettingsActionEnum.WARNING_LIGHT_SCHEDULE,
        iprId: update.assetId,
        payload: {
          scheme: updateItem.value,
        },
      };
};

export const mapHeadlightsExecutionTargets = (update: Update) => {
  const list: unknown[] = [];
  const theme = mapWarningLightThemeTarget(update);
  const errorIndication = mapWarningLightErrorIndicationEnabledTarget(update);
  const mode = mapWarningLightModeTarget(update);
  if (errorIndication !== undefined) {
    list.push(errorIndication);
  }
  if (theme !== undefined) {
    list.push(theme);
  }
  if (mode !== undefined) {
    list.push(mode);
  }
  return list;
};
